<div
	class="dropzone"
	[class.hover-event]="eventDragCounter > 0"
	(click)="fileUpload.click()"
	(dragover)="onDragOver($event)"
	(dragenter)="onDragEnter($event)"
	(dragleave)="onDragLeave($event)"
	(drop)="onDropFile($event)"
>
	<i class="bi bi-upload text-primary"></i>
	<div>
		<span class="text-muted">
			Clique aqui para selecionar o arquivo ou arraste-o para cá
		</span>
	</div>
	<input
		(change)="onChangeFiles($event)"
		type="file"
		id="filedrop"
		[multiple]="multiple"
		[accept]="accept"
		#fileUpload
	/>
</div>

<div *ngIf="files.length" class="my-4">
	<h5 class="fw-bold text-uppercase ms-4">Nome do arquivo</h5>
	<ng-container *ngFor="let file of files; let i = index">
		<div class="body-file my-2">
			<i class="bi bi-file-earmark-text icon me-2 align-middle"></i>
			<span class="text-muted align-middle">{{ file.name }}</span>
			<i
				(click)="eraseFileToUpload(i)"
				class="bi bi-trash icon icon-trash"
			></i>
		</div>
	</ng-container>
</div>
